
import { ChatRepository } from '../repositories/ChatRepository';

export class ChatService {
  private repository: ChatRepository;

  constructor() {
    this.repository = ChatRepository.getInstance();
  }

  /**
   * Get all models
   */
  public async chatCompletions(payload: any): Promise<any> {
    return await this.repository.chatCompletions(payload);
  }

  public async streamChatCompletion(
    body: any,
    onToken: (token: string) => void,
    onDone: () => void,
    onError: (err: any) => void,
    onWarning?: (warning: { type: string; message: string }) => void 

  ) {
    return this.repository.streamChatCompletion(body, onToken, onDone, onError, onWarning);
  }

}

// Export singleton instance
export const chatService = new ChatService();
